<div class="quantity-selector" role="group" aria-label="Selector de cantidad">
  <button
    class="quantity-selector__btn"
    type="button"
    aria-label="Disminuir cantidad"
    [disabled]="disabled() || quantity() <= 1"
    [attr.aria-disabled]="disabled() || quantity() <= 1"
    (click)="decrement()"
  >
    −
  </button>

  <input
    class="quantity-selector__input"
    type="number"
    [value]="quantity()"
    [disabled]="disabled()"
    [attr.aria-valuenow]="quantity()"
    aria-valuemin="1"
    [attr.aria-valuemax]="maxQuantity"
    aria-label="Cantidad"
    min="1"
    [attr.max]="maxQuantity"
    (input)="onInputChange($event)"
  />

  <button
    class="quantity-selector__btn"
    type="button"
    aria-label="Aumentar cantidad"
    [disabled]="disabled() || quantity() >= maxQuantity"
    [attr.aria-disabled]="disabled() || quantity() >= maxQuantity"
    (click)="increment()"
  >
    +
  </button>
</div>
